/**
 * DevExtreme (esm/events/index.js)
 * Version: 23.2.4
 * Build date: Mon Jan 29 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import eventsEngine from "./core/events_engine";
export var on = eventsEngine.on;
export var one = eventsEngine.one;
export var off = eventsEngine.off;
export var trigger = eventsEngine.trigger;
export var triggerHandler = eventsEngine.triggerHandler;
export var Event = eventsEngine.Event;
